import { useState } from "react";
import { MessageBarType } from "@fluentui/react";
export function useForm<T>(initial: T) {
    const [form, setForm] = useState<T>(initial);
    const [errorMessages, setErrorMessages] = useState({});
    const [summaryText, setSummaryText] = useState("");
    const [summaryType, setSummaryType] = useState<MessageBarType>(MessageBarType.info);

    const setField = <K extends keyof T>(key: K, value: T[K]) => {
        setForm(prev => ({ ...prev, [key]: value }));
    };

    const resetForm = () => {
        setForm(initial);
    };

    return {
        form,
        setForm,
        setField,
        resetForm,
        errorMessages,
        setErrorMessages,
        summaryText,
        setSummaryText,
        summaryType,
        setSummaryType
    };
}